import type * as ecModels from '../../../models'

/**
 * {@link https://ngrx.io/docs State} of this plugin
 */
export interface State<
  TTypeParams extends ecModels.TypeParams = ecModels.TypeParams,
> {
  // Currently, everything is in storage
}
export namespace State {
  export const INITIAL: State = {}
}
